// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Localidades_SalvabairroResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for salvaBairro() /localidades/salvaBairro
 *
 * Proxy to locations-service (Go microservice).
 * Returns the saved neighborhood (bairro) record.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Localidades_SalvabairroResponseDados {
id?: number
name?: string
city_id?: number
}

export type Localidades_SalvabairroResponse = ApiResponse<Localidades_SalvabairroResponseDados>;

registerResponseContract('Localidades_SalvabairroResponse', {
  id:      { type: 'number',  required: false },
  name:    { type: 'string',  required: false },
  city_id: { type: 'number',  required: false },
})
